// extracted by css-extract-rspack-plugin
export default {"second_drawer":"second_drawer-k2QJfg","secondDrawer":"second_drawer-k2QJfg"};